import { LitElement, html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import Styles from './vm-video-education-events.scss';
import 'Components/atoms/vm-icon-next/vm-icon-next';
import '../vm-video-education-event-card/vm-video-education-event-card';

/**
 * A sidebar section listing upcoming education events related to a video.
 *
 * Event cards (`<vm-video-education-event-card>`) are projected through the
 * default slot. When more than one card is present only the first is shown,
 * until the "See more events" toggle is pressed, which reveals the rest.
 */
@customElement('vm-video-education-events')
export class VmVideoEducationEvents extends LitElement {
    static override styles = Styles;

    @property({ type: String }) heading = 'Upcoming events';

    @state() private _expanded = false;
    @state() private _count = 0;

    private handleSlotChange(event: Event) {
        const slot = event.target as HTMLSlotElement;
        this._count = slot.assignedElements().length;
    }

    private expand() {
        this._expanded = true;
    }

    override render() {
        const showToggle = this._count > 1 && !this._expanded;

        return html`
            <div class="vm-video-education-events" ?data-collapsed=${!this._expanded}>
                <h3 class="vm-video-education-events__title">${this.heading}</h3>
                <div class="vm-video-education-events__list">
                    <slot @slotchange=${this.handleSlotChange}></slot>
                </div>
                ${showToggle
                    ? html`<button type="button" class="vm-video-education-events__toggle" @click=${this.expand}>
                          See more events
                          <vm-icon-next name="chevron-down" size="sm"></vm-icon-next>
                      </button>`
                    : nothing}
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-video-education-events': VmVideoEducationEvents;
    }
}
